import { IUIError } from "@gtmhub/error-handling";
import { ILookerEntity, DatasourceConfig } from "../models/models";

export const configUIError = (config: DatasourceConfig, entities: { tiles: ILookerEntity[]; looks: ILookerEntity[] }): IUIError => {
  const { tiles, looks } = entities;

  return { body: `configuration error: config: ${JSON.stringify(config)}; tiles ids: ${tiles.map((t) => t.id)}; loooks ids: ${looks.map((l) => l.id)}` };
};
